import React, { FunctionComponent, useEffect, useState } from "react";
import CodeIntro from "../../molecules/codeIntro";
import styled from "styled-components";
import { Router } from "react-router-dom";

const DetailWrapper = styled.div`
  position: sticky;
  top: 70px;
`;

const Name = styled.h2`
  font-family: Montserrat, sans-serif;
  font-weight: 400;
  line-height: 1.9em;
  color: white;
  padding-bottom: 2px;
  margin-bottom: 2px;
  font-size: 40px;
`;

const Role = styled.h4`
  font-family: Montserrat, sans-serif;
  font-weight: 400;
  line-height: 1.9em;
  color: white;
  margin: 5px 0px;
`;

const MainDetails: FunctionComponent = () => {
  return (
    <DetailWrapper>
      <Name>ELBERT WAN</Name>
      <Role>Typescript Fullstack Software Engineer</Role>
      <Role>(8 years — Senior Consultant &amp; Engineer)</Role>
    </DetailWrapper>
  );
};

export default MainDetails;
